import React from "react"
import tw, { styled } from "twin.macro"

const Tray = ({ children }) => (
  <Style className="tray" tabIndex="-1">
    {children}
  </Style>
)

export default Tray

const Style = styled.div`
  background-color: rgb(1, 1, 1);
  min-height: 100vh;
  min-height: 100dvh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${tw`text-white`}
  border-left: 1px solid rgba(0,0,0,.75);
  outline: none;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    height: 100%;
    width: 0.75vw;
    top: 0;
    background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.175),
      transparent
    );
  }
`
